import React, { useState } from 'react';
import dataService from '../services/dataService';
import { useToast } from '../context/ToastContext';

const SalesPersonModal = ({ isOpen, onClose, salesPersons, onUpdate }) => {
    const [newName, setNewName] = useState('');
    const [loading, setLoading] = useState(false);
    const { addToast } = useToast();

    if (!isOpen) return null;

    const handleAdd = async (e) => {
        e.preventDefault();
        if (!newName.trim()) return;

        setLoading(true);
        try {
            await dataService.addSalesPerson({ name: newName.trim() });
            setNewName('');
            addToast('Sales person added successfully', 'success');
            onUpdate(); // Refresh the list
        } catch (err) {
            addToast(err.response?.data?.message || 'Failed to add sales person', 'error');
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Are you sure you want to delete this sales person?')) return;

        try {
            await dataService.deleteSalesPerson(id);
            addToast('Sales person deleted successfully', 'success');
            onUpdate(); // Refresh the list
        } catch (err) {
            addToast('Failed to delete sales person', 'error');
        }
    };

    return (
        <div className="modal-overlay" style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
            justifyContent: 'center', alignItems: 'center', zIndex: 2000
        }}>
            <div className="modal-content" style={{
                backgroundColor: 'white', padding: '24px', borderRadius: '8px',
                width: '400px', maxWidth: '90%', boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
            }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                    <h2 style={{ margin: 0 }}>Manage Sales Persons</h2>
                    <button onClick={onClose} style={{
                        background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#6B7280'
                    }}>&times;</button>
                </div>

                <form onSubmit={handleAdd} style={{ marginBottom: '20px', display: 'flex', gap: '8px' }}>
                    <input
                        type="text"
                        value={newName}
                        onChange={(e) => setNewName(e.target.value)}
                        placeholder="New Sales Person Name"
                        style={{
                            flex: 1, padding: '8px 12px', border: '1px solid #D1D5DB',
                            borderRadius: '4px', outline: 'none'
                        }}
                    />
                    <button type="submit" disabled={loading} style={{
                        padding: '8px 16px', backgroundColor: '#2563EB', color: 'white',
                        border: 'none', borderRadius: '4px', cursor: 'pointer'
                    }}>
                        {loading ? '...' : 'Add'}
                    </button>
                </form>

                <div style={{ maxHeight: '300px', overflowY: 'auto', border: '1px solid #F3F4F6', borderRadius: '4px' }}>
                    {salesPersons.length === 0 ? (
                        <p style={{ padding: '12px', textAlign: 'center', color: '#9CA3AF', fontSize: '14px' }}>No sales persons found</p>
                    ) : (
                        salesPersons.map((person) => (
                            <div key={person._id} style={{
                                display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                                padding: '10px 12px', borderBottom: '1px solid #F3F4F6'
                            }}>
                                <span style={{ fontSize: '14px' }}>{person.name}</span>
                                <button
                                    onClick={() => handleDelete(person._id)}
                                    style={{
                                        background: '#FEE2E2', color: '#DC2626', border: 'none',
                                        borderRadius: '4px', padding: '2px 8px', cursor: 'pointer', fontSize: '12px'
                                    }}
                                >
                                    Delete
                                </button>
                            </div>
                        ))
                    )}
                </div>

                <div style={{ marginTop: '20px', textAlign: 'right' }}>
                    <button onClick={onClose} style={{
                        padding: '8px 16px', border: '1px solid #D1D5DB',
                        borderRadius: '4px', background: 'white', cursor: 'pointer'
                    }}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SalesPersonModal;
